<template>
    <div :class="className" :keyId="keyId" :data-spm="spm" data-spm-type="all">
        <slot name="main">
            <div class="mHead" v-if="showHead && list.length >0">
                <h3 class="l-title">{{title}}</h3>
                <a :href="linkUrl" v-if="linkUrl" class="more">更多</a>
            </div>
            <div :id="autoId" class="temID" v-if="list.length >0">
                <div class="mBody">
                    <template v-for="arr in list">
                        <div class="inner">
                             <a v-for="item in arr" class="l-item" :data-spm="item.id" :href="item.adUrl">
                                 <article>
                                     <span class="l-img" v-if="item._adContent">
                                         <img :alt="item.adName" :src="item._adContent" :title="item.adName" @load="toCache($event)"/>
                                     </span>
                                     <span class="l-title" :title="item.adName">{{item.adName}}</span>
                                 </article>
                             </a>
                        </div>
                    </template>
                    <!-- <template v-if="linkUrl">
                        <div class="inner">
                            <a class="l-item mui-clearfix l-more" :href="linkUrl" data-spm="more">
                                <article>
                                    <span class="l-img">
                                        <img src="../assets/img/more.png">
                                    </span>
                                </article>
                            </a>
                        </div>
                    </template> -->
                </div>
            </div>
        </slot>
        <slot name="tab">
            <div class="mTab" :id="tabId" v-if="hasTab && list.length>1">
                <span v-for="arr in list"></span>
            </div>
        </slot>
    </div>
</template>
<script>

    import serverUtil from "cy_static/serverUtil";
    import cache from "cy_static/cache";
    export default {
        name: 'adModule',
        props: {
            keyId: {// keyId多个以，分隔
                type: String
            },
            drag: {// 阻你系数
            },
            spm: {// data-spm
                type: String
            },
            className: {// 样式名称
                type: String
            },
            showHead: {// 显示底下小tab
                type: String
            },
            hasTab: {// 显示底下小tab
                type: String
            },
            url: {// 接口路径
                type: String
            },
            scrollElem: {// 滚动元素
                type: String
            },
            row: {// 从第几行开始补全其他ITEM
                default: -1
            },
            max: {// 最大显示多少条记录
                default: 100
            },
            minScrollNum: {// 最大显示多少条记录
                default: 1
            },
            defLen: {// 默认一行几个
                default: 1
            },
            column: {// 设置每行几个
                type: Array,
                default: function () {
                    return [];
                }
            },// cnd图片路径
            baseImgUrl: {
                type: String,
                default: "//m.changyoyo.com/"
            },
            cacheImg: {// 缓存图片数量
                type: String
            },
            cacheImgTime: {// 缓存图片时间3天
                type: String,
                default: "259200000"
            }
        },
        data: function () {
            return {
                autoId : ('a' + Math.random()).replace(".", ""),
                tabId : ('tab' + Math.random()).replace(".", ""),
                title :"",
                linkUrl :"",
                list: [[]]
            }
        },
        mounted (){
            let m = this;
            serverUtil.loadRecommend({keyIds: m.keyId}, function (keyId, list) {
                list = list.slice(0, m.max);
                if(m.keyId === 'H5_MyList'){
                  // 我的-常用工具标题固定，不需要读取第一个
                  m.title = "常用工具";
                }else if (m.showHead && list[0]) {
                    let more = list.length ? list.shift() : null;
                    if (more) {
                        m.linkUrl = more.adUrl;
                        m.title = more.adDesc;
                    }
                }
                list.forEach(function(item,index) {
                    item.adUrl == 'https://www.changyoyo.com' && (item.adUrl = '', item.id = 'no');
                    let iscache = m.cacheImg && m.cacheImg>index && cache.localStorage;
                    let imgUrl = (iscache ? "//" + location.host : m.baseImgUrl) + "/" + item.adContent, text;
                    if (iscache) {
                        text = cache.get(item.adContent);
                        imgUrl = text ? text : imgUrl;
                    }
                    item._adContent = imgUrl;
                })
                list = list.slice();
                let __data = [], num = 0, len = 0, difLen = 0, temArr = [];
                while (list.length) {
                    len = m.column[num] || m.defLen;
                    temArr = list.splice(0, len);
                    difLen = len - temArr.length;
                    if (difLen > 0 && num > m.row) {
                        for (let z = 0; z < difLen; z++) {
                            temArr.push({});
                        }
                    }
                    __data.push(temArr.splice(0));
                    num++;
                }
                m.list = __data;
                if (m.scrollElem && __data.length > m.minScrollNum) {
                    setTimeout(function () {
                        m.loadSlider(function () {
                            window.Slider({
                                drag : m.drag ? parseFloat(m.drag): 0.8, 	// 阻尔糸数
                                elem : "#" + m.autoId, 	// 滑动元素选择器
                                content :"#" + m.autoId + " " + m.scrollElem, 	// 滚动元素选择器
                                onFinish:function (mumber) {
                                    m.hasTab && m.switchTab(--mumber);
                                }
                            });
                            m.hasTab && m.switchTab(0);
                        });
                    },200)
                }
            })
        },
        methods: {
            toCache(event){
                let m = this;
                if (!m.cacheImg) {return;}
                cache.toCacheImg(event.currentTarget, parseInt(m.cacheImgTime));
            },
            switchTab : function (number) {
                let m = this;
                let item, run, activeCss = "active";
                item = document.querySelectorAll("#" + m.tabId + " span");
                run = function() {
                    if (!item) return;
                    for (var i = 0;i< item.length;i++) {
                        item[i].classList.remove(activeCss);
                        if (i == number) {
                            item[i].classList.add(activeCss);
                        }
                    }
                };
                run();
            },
            loadSlider : function (callback) {
                if (window.Slider) {
                    callback();
                } else {
                    var script = document.createElement("script");
                    script.type = "text/javascript";
                    script.src = "/static/js/common/slider.js";
                    document.getElementsByTagName('head')[0].appendChild(script);
                    script.onload = function() {
                        callback();
                    }
                }
            }
        }
    }
</script>
